import {isIamSchoolStudent} from '@iamschoolpc/utils/serviceType.js';

export const emitGaPageView = async (route) => {
    let pageTitle = findRouteMeta(route, meta => meta.pageTitle);

    if (!pageTitle) {
        return;
    }

    if (document.location.pathname.match(/\/iamteacherapp/)) {
        try {
            await window.teacherAnalytics.init(process.env.VUE_APP_TEACHER_APP);
        } finally {
            window.teacherAnalytics.pageView({page_title: pageTitle}, false);
        }

    } else {
        const gaId = isIamSchoolStudent() ? process.env.VUE_APP_NOTICE_STUDENT_APP : process.env.VUE_APP_NOTICE_PARENT_APP;
        try {
            await window.schoolAnalytics.init(gaId);
        } finally {
            window.schoolAnalytics.pageView({page_title: pageTitle}, false);
        }
    }
};

export function findRouteMeta(route, predicate) {
    return predicate(route.meta) || predicate(route.matched.find(r => predicate(r.meta))?.meta || {});
}
